<!-- Mobile backdrop -->
<div
  class="filter-sidebar__backdrop"
  [class.filter-sidebar__backdrop--visible]="isOpen()"
  aria-hidden="true"
  (click)="drawerClose.emit()"
></div>

<aside
  class="filter-sidebar"
  [class.filter-sidebar--open]="isOpen()"
  aria-label="Filtros"
>
  <div class="filter-sidebar__header">
    <h2 class="filter-sidebar__title">Filtros</h2>
    <button
      class="filter-sidebar__close"
      type="button"
      aria-label="Cerrar filtros"
      (click)="drawerClose.emit()"
    >
      ✕
    </button>
  </div>

  @for (section of sections(); track section.id) {
    <div class="filter-sidebar__section">
      <button
        class="filter-sidebar__section-header"
        type="button"
        [attr.aria-expanded]="!isSectionCollapsed(section.id)"
        [attr.aria-controls]="'filter-' + section.id"
        (click)="toggleSection(section.id)"
      >
        <span class="filter-sidebar__section-title">{{ section.title }}</span>
        <span
          class="filter-sidebar__chevron"
          [class.filter-sidebar__chevron--collapsed]="isSectionCollapsed(section.id)"
          aria-hidden="true"
        >›</span>
      </button>

      <div
        class="filter-sidebar__section-body"
        [class.filter-sidebar__section-body--collapsed]="isSectionCollapsed(section.id)"
        [id]="'filter-' + section.id"
      >
        <div class="filter-sidebar__section-body-inner">
        @if (hasSearch(section)) {
          <app-input
            [id]="section.id + '-search'"
            type="text"
            [placeholder]="searchPlaceholder"
            [ariaLabel]="searchAriaLabel(section)"
            [value]="searchTerm(section.id)"
            (valueChange)="onSearchTermChange(section.id, $event)"
          />
        }
        @switch (section.type) {
          @case ('checkbox') {
            @if (noMatches(section)) {
              <p class="filter-sidebar__search-empty" aria-live="polite">
                {{ noMatchesMessage(section) }}
              </p>
            } @else {
              <ul class="filter-sidebar__options" role="list" aria-live="polite">
                @for (opt of displayedOptions(section); track opt.value) {
                  <li class="filter-sidebar__option">
                    <app-checkbox
                      [id]="section.id + '-' + opt.value"
                      [label]="opt.label + (opt.count != null ? ' (' + opt.count + ')' : '')"
                      [checked]="isChecked(section.id, opt.value)"
                      (checkedChange)="onCheckboxChange(section.id, opt.value, $event)"
                    />
                  </li>
                }
              </ul>
            }
            @if (hasOverflow(section) && !hasActiveSearch(section.id)) {
              <button
                class="filter-sidebar__see-more"
                type="button"
                [attr.aria-expanded]="isOptionsExpanded(section.id)"
                [attr.aria-controls]="'filter-' + section.id"
                (click)="toggleOptionsExpanded(section.id)"
              >
                <span>
                  @if (isOptionsExpanded(section.id)) {
                    Ver menos
                  } @else {
                    Ver más ({{ hiddenCount(section) }})
                  }
                </span>
                <span
                  class="filter-sidebar__see-more-chevron"
                  [class.filter-sidebar__see-more-chevron--expanded]="isOptionsExpanded(section.id)"
                  aria-hidden="true"
                >›</span>
              </button>
            }
          }
          @case ('radio') {
            @if (noMatches(section)) {
              <p class="filter-sidebar__search-empty" aria-live="polite">
                {{ noMatchesMessage(section) }}
              </p>
            } @else {
              <ul class="filter-sidebar__options" role="list" aria-live="polite">
                @for (opt of displayedOptions(section); track opt.value) {
                  <li class="filter-sidebar__option">
                    <app-radio
                      [id]="section.id + '-' + opt.value"
                      [name]="section.id"
                      [value]="opt.value"
                      [label]="opt.label + (opt.count != null ? ' (' + opt.count + ')' : '')"
                      [selectedValue]="getRadioValue(section.id)"
                      (valueChange)="onRadioChange(section.id, $event)"
                    />
                  </li>
                }
              </ul>
            }
            @if (hasOverflow(section) && !hasActiveSearch(section.id)) {
              <button
                class="filter-sidebar__see-more"
                type="button"
                [attr.aria-expanded]="isOptionsExpanded(section.id)"
                [attr.aria-controls]="'filter-' + section.id"
                (click)="toggleOptionsExpanded(section.id)"
              >
                <span>
                  @if (isOptionsExpanded(section.id)) {
                    Ver menos
                  } @else {
                    Ver más ({{ hiddenCount(section) }})
                  }
                </span>
                <span
                  class="filter-sidebar__see-more-chevron"
                  [class.filter-sidebar__see-more-chevron--expanded]="isOptionsExpanded(section.id)"
                  aria-hidden="true"
                >›</span>
              </button>
            }
          }
          @case ('range') {
            <div class="filter-sidebar__range-row">
              <app-input
                [id]="section.id + '-min'"
                label="Min"
                type="number"
                [placeholder]="section.min != null ? '' + section.min : '0'"
                [value]="getRangeMin(section.id)"
                (valueChange)="onRangeChange(section.id, 'min', $event)"
              />
              <span class="filter-sidebar__range-separator">—</span>
              <app-input
                [id]="section.id + '-max'"
                label="Max"
                type="number"
                [placeholder]="section.max != null ? '' + section.max : '∞'"
                [value]="getRangeMax(section.id)"
                (valueChange)="onRangeChange(section.id, 'max', $event)"
              />
            </div>
          }
        }
        </div>
      </div>
    </div>
  }
</aside>
